import { ILocalizedEntity } from '@shared/models/proto/base/localized-entity'

export default function getLocalizedLabel(
  labels: ILocalizedEntity[] = [],
  userLocale: string
): ILocalizedEntity {
  const foundData = labels.find((item) => item.locale === userLocale)
  const fallbackData = { value: '', locale: '' }

  // we return a found data
  // or a fallback english variant
  // if english does not exist -> return empty values

  return foundData || labels.find((item) => item.value) || fallbackData
}
